import en from "@/localization/en.json";
import { FilterIcon } from "@/components/data-display/Icon";

function FilterByBtn() {
  return (
    <div className="min-w-[9.5rem] min-h-[2.5rem] bg-grayD6 rounded-[2.625rem] cursor-pointer text flex justify-center items-center">
      <label
        className=" text-grayD1 w-full text-center flex items-center justify-center space-x-3 text-[0.875rem]"
        htmlFor="filter-modal"
      >
        <FilterIcon />
        <p>{en["common.filter_by"]}</p>
      </label>
    </div>
  );
}

export default FilterByBtn;
